import useFetchObjects from "../../api/useFetchObjects";

const useTeamMembers = () => {
  const {
    data: teamMembers,
    loading,
    error,
    refetch,
  } = useFetchObjects(["team"], "team-members/");

  return {
    teamMembers,
    loading,
    error,
    refetch,
  };
};

export default useTeamMembers;
